import { render, staticRenderFns } from "./QuickMenuBusinessComponent.vue?vue&type=template&id=0e72fcc4&"
import script from "./QuickMenuBusinessComponent.vue?vue&type=script&lang=js&"
export * from "./QuickMenuBusinessComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
